import { motion } from "framer-motion";
import { cta } from "@/data/showcase";
import { fadeUp, viewportOnce } from "@/lib/motion";

const { primaryCta, modules } = cta;

export function Cta() {
  return (
    <section className="relative bg-[#06080F] border-t border-ink-900 py-24 md:py-32 overflow-hidden">
      {/* Single asymmetric purple wash, off-center */}
      <div
        aria-hidden
        className="absolute pointer-events-none"
        style={{
          top: "10%",
          left: "-20%",
          width: "70%",
          height: "60%",
          background:
            "radial-gradient(ellipse at center, rgba(141,81,255,0.18), transparent 60%)",
          filter: "blur(20px)",
        }}
      />
      {/* Hairline divider at top — editorial section break */}
      <div
        aria-hidden
        className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-px"
        style={{ background: "rgba(255,255,255,0.2)" }}
      />

      <div className="relative mx-auto max-w-[960px] px-6">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
        >
          {/* Tiny vertical mark — like a publication colophon */}
          <p className="font-mono text-[10px] uppercase tracking-[0.4em] text-ink-500 mb-12">
            Foton · v.1
          </p>

          {/* Massive editorial closing statement, no decoration */}
          <h2 className="font-serif text-white leading-[0.95] tracking-tight mb-16 text-[clamp(40px,7.5vw,96px)] max-w-[20ch]">
            Pokazaliśmy w szczególe jeden moduł — analizę postępu.{" "}
            <span
              className="italic"
              style={{ fontFamily: "Fraunces, 'Source Serif 4', serif", fontWeight: 400 }}
            >
              Foton ma jeszcze siedem innych.
            </span>
          </h2>

          {/* Single CTA — no surrounding noise */}
          <a
            href={primaryCta.href}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-baseline gap-3 font-mono text-sm uppercase tracking-[0.2em] text-white border-b border-ink-700 hover:border-foton-light pb-2 transition-colors"
          >
            <span>{primaryCta.label}</span>
            <span
              aria-hidden
              className="text-foton-lighter group-hover:translate-x-1 transition-transform"
            >
              →
            </span>
          </a>

          {/* Module list — annotation-style mono footer, NOT a grid of cards */}
          <div className="mt-24 pt-8 border-t border-ink-800">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink-500 mb-5">
              Foton · pełna platforma
            </p>
            <ul className="font-mono text-xs text-ink-400 leading-loose columns-2 md:columns-3 gap-x-8 max-w-[640px]">
              {modules.map((m) => (
                <li key={m.name} className="break-inside-avoid">
                  <span className={m.primary ? "text-foton-lighter" : "text-ink-300"}>
                    {m.name}
                  </span>
                  <span className="text-ink-600"> · {m.sub}</span>
                </li>
              ))}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
